module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10247.5ca9266b.jpg";